import { createContext } from 'react';

type FeatureValue = 'disabled' | string; // TODO: improve this type (requires bigger refactor)
type FeatureData = Record<string, FeatureValue>;

export const FeatureContext = createContext<FeatureData>({});
